import React from "react";

import styles from "../../styles/shared-module-css/heading.module.css";

const Heading = ({
  onClose,
  title,
  content,
  actions,
  bodyHeight,
  bodyClassName = "",
  className = ""
}) => {
  return (
    <div className={`${styles.comp} ${className}`}>
      <div
        className={`${styles.comp_header}`}
        onClick={onClose}
      >
        <p className={styles.comp_heading}>{title}</p>

        <div className={styles.comp_actions}>
          {Array.isArray(actions) && actions.length > 0 && (
            <div
              className={styles.actions_wrapper}
              onClick={(e) => e.stopPropagation()}
            >
              {React.Children.map(actions, (action) =>
                React.isValidElement(action)
                  ? React.cloneElement(action, {
                      className: `${styles.action} ${
                        action.props["data-selected"] ? styles.selected : ""
                      }`,
                    })
                  : action
              )}
            </div>
          )}
        </div>
      </div>
      <div
        className={`${styles.comp_body} ${bodyClassName}`}
        style={{ height: bodyHeight }}
      >
        {content}
      </div>
    </div>
  );
};

export default Heading;
